import { render, staticRenderFns } from "./UBtn.vue?vue&type=template&id=5eb7b3e4&scoped=true"
import script from "./UBtn.vue?vue&type=script&lang=js"
export * from "./UBtn.vue?vue&type=script&lang=js"
import style0 from "./UBtn.vue?vue&type=style&index=0&id=5eb7b3e4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5eb7b3e4",
  null
  
)

export default component.exports